export const analyticsDashboard = {
  // Common analytics card translations
  noHistoricalDataAvailable: "No historical data available",
  details: "Details",
  viewDetails: "View details",
  storeName: "Store name",
  last30Days: "Last 30 days",
  monthToDate: "Month-to-date",
  past12Months: "Past 12 months",
  last12Months: "Last 12 months",
  errorLoadingData: "There was a problem loading the data",

  // AnalyticsItemTable shared component (PLAT-2586)
  itemTable: {
    softDeletedProtocol: "This protocol has been deleted.",
    archivedAuthor: "This author's account has been archived.",
    emptyState: {
      default: {
        title: "No data to display",
        description: "There's nothing to show in this view yet.",
      },
      protocols: {
        title: "No protocols sold in this period",
        description: "Try a different time range to see protocol sales.",
      },
    },
  },
};
